import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ProductPageProvider } from "@/components";
import { ReducedMotionProvider } from "@tripbox/ui";
import { App as AntdApp } from "antd";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { TenantProvider } from "./tenant/TenantProvider";

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ProductPageProvider>
      <ReducedMotionProvider>
        <AntdApp>
          <QueryClientProvider client={queryClient}>
            <TenantProvider>
              <App />
            </TenantProvider>
          </QueryClientProvider>
        </AntdApp>
      </ReducedMotionProvider>
    </ProductPageProvider>
  </StrictMode>,
);
